import React from "react";
import "./App.css";
import { Router } from "./components/Router";

const App: React.FC = () => {
  return (
    <div className="App">
      <Router />
    </div>
  );
};

export default App;
